<div
  *appHasAccess="['P2P_OPERATION']"
  class="payment-card">
  <div class="payment-card__timer">
    <p
      *ngIf="time > 0"
      class="payment-card__timer-content">
      {{ time | timer }}
    </p>
    <p
      *ngIf="time < 0"
      class="payment-card__timer-content">
      {{ "PAYMENT_TO_CARD_PAGE.TIME_OUT" | translate }}
    </p>
  </div>
  <div class="payment-card__left">
    <h2 class="headline">
      {{ "PAYMENT_TO_CARD_PAGE.FROM_CARD" | translate }}
    </h2>
    <ul *appHasAccess="['CARDS_VIEW']" class="payment-card__left-tab">
      <li
        [class.active]="tabSelect === 'new'"
        (click)="selectTab('new')"
        class="item">
        {{ "PAYMENT_TO_CARD_PAGE.TAB_1" | translate }}
      </li>
      <li
        [class.active]="tabSelect === 'saved'"
        (click)="selectTab('saved')"
        class="item">
        {{ "PAYMENT_TO_CARD_PAGE.TAB_2" | translate }}
      </li>
    </ul>
    <div class="payment-card__left-content">
      <div
        *ngIf="tabSelect === 'new'"
        class="tab">
        <div class="new-card">
          <div class="new-card__line">
            <input
              [(ngModel)]="cardNumberFrom"
              mask="0000 0000 0000 0000"
              inputmode="numeric"
              type="text"
              placeholder="{{ 'PAYMENT_TO_CARD_PAGE.CARD_NUMBER' | translate }}"
              class="new-card__line-input" />
          </div>
          <div class="new-card__line">
            <input
              [(ngModel)]="mount"
              (input)="checkMaxMount()"
              mask="00"
              inputmode="numeric"
              type="text"
              placeholder="{{ 'PAYMENT_TO_CARD_PAGE.MOUNT' | translate }}"
              class="new-card__line-input mount" />
            <span class="decor">/</span>
            <input
              [(ngModel)]="year"
              mask="00"
              inputmode="numeric"
              type="text"
              placeholder="{{ 'PAYMENT_TO_CARD_PAGE.YEAR' | translate }}"
              class="new-card__line-input year" />
            <input
              [(ngModel)]="cvv"
              mask="000"
              inputmode="numeric"
              type="text"
              placeholder="{{ 'PAYMENT_TO_CARD_PAGE.CVV' | translate }}"
              class="new-card__line-input cvv" />
          </div>
          <div class="new-card__line">
            <input
              [(ngModel)]="cardHolderNameFrom"
              type="text"
              placeholder="{{ 'PAYMENT_TO_CARD_PAGE.CARD_HOLDER' | translate }}"
              class="new-card__line-input" />
          </div>
        </div>
      </div>
      <div
        *ngIf="tabSelect === 'saved'"
        class="tab">
        <div class="card">
          <div
            *ngFor="let item of savedCardList"
            [class.active]="item.id === selectedCard?.id"
            [class.mainCard]="item.is_main"
            (click)="selectCard(item)"
            class="card__item">
            <app-card-item
              [isEditable]="false"
              [item]="item"></app-card-item>
          </div>
        </div>
      </div>
    </div>
  </div>

  <form
    *ngIf="virtualPosId && loaded"
    [formGroup]="form"
    (submit)="sendP2p()"
    class="payment-card__right">
    <h2 class="headline">
      {{ "PAYMENT_TO_CARD_PAGE.TO_CARD" | translate }}
    </h2>
    <div class="payment-card__right-recipient">
      <div class="line">
        <div
          [class.error]="form.get('cardNumberFormControl')?.invalid && form.get('cardNumberFormControl')?.touched"
          class="input-block">
          <input
            formControlName="cardNumberFormControl"
            mask="0000 0000 0000 0000"
            id="cardNumber"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="cardNumber"
            class="placeholder">
            {{ "PAYMENT_TO_CARD_PAGE.CARD_NUMBER" | translate }}*
          </label>
          <ng-container *ngIf="form.get('cardNumberFormControl')?.invalid && form.get('cardNumberFormControl')?.touched">
            <span
              *ngIf="cardNumberFormatError"
              class="input-block__error">
              {{ "PAYMENT_TO_CARD_PAGE.ERRORS.CARD_NUMBER_FORMAT_ERROR" | translate }}
            </span>
            <span
              *ngIf="cardNumberRequiredError"
              class="input-block__error">
              {{ "PAYMENT_TO_CARD_PAGE.ERRORS.CARD_NUMBER_REQUIRED" | translate }}
            </span>
          </ng-container>
        </div>
      </div>
      <div class="line">
        <div
          [class.error]="form.get('sumFormControl')?.invalid && form.get('sumFormControl')?.touched"
          class="input-block">
          <input
            formControlName="sumFormControl"
            mask="separator.2"
            id="sum"
            class="input"
            type="text"
            placeholder=" " />
          <div class="currency">{{ currency }}</div>
          <label
            for="sum"
            class="placeholder">
            {{ "PAYMENT_TO_CARD_PAGE.SUM" | translate }}*
          </label>
          <ng-container *ngIf="form.get('sumFormControl')?.invalid && form.get('sumFormControl')?.touched">
            <span
              *ngIf="sumRequiredError"
              class="input-block__error">
              {{ "PAYMENT_TO_CARD_PAGE.ERRORS.SUM_REQUIRED" | translate }}
            </span>
          </ng-container>
        </div>
      </div>
      <p class="description">
        {{ "PAYMENT_TO_CARD_PAGE.COMMISSION" | translate }}
      </p>
      <div class="line">
        <div class="input-line">
          <div
            [class.error]="form.get('nameFormControl')?.invalid && form.get('nameFormControl')?.touched"
            class="input-block">
            <input
              formControlName="nameFormControl"
              id="name"
              class="input"
              type="text"
              placeholder=" " />
            <label
              for="name"
              class="placeholder">
              {{ "PAYMENT_TO_CARD_PAGE.RECIPIENT_NAME" | translate }}*
            </label>
            <ng-container *ngIf="form.get('nameFormControl')?.invalid && form.get('nameFormControl')?.touched">
              <span
                *ngIf="nameRequiredError"
                class="input-block__error">
                {{ "PAYMENT_TO_CARD_PAGE.ERRORS.NAME_REQUIRED" | translate }}
              </span>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="line">
        <div class="input-line">
          <div
            [class.error]="form.get('commentFormControl')?.invalid && form.get('commentFormControl')?.touched"
            class="input-block textarea">
            <textarea
              formControlName="commentFormControl"
              id="comment"
              placeholder=" "
              class="input"></textarea>
            <label
              for="comment"
              class="placeholder">
              {{ "PAYMENT_TO_CARD_PAGE.COMMENT" | translate }}*
            </label>
            <ng-container *ngIf="form.get('commentFormControl')?.invalid && form.get('commentFormControl')?.touched">
              <span
                *ngIf="commentRequiredError"
                class="input-block__error">
                {{ "PAYMENT_TO_CARD_PAGE.ERRORS.COMMENT_REQUIRED" | translate }}
              </span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="payment-card__right-total">
      <p class="total-sum">
        {{ form.get("sum")?.value }}
        {{ "PAYMENT_TO_CARD_PAGE.SUM_TOTAL" | translate }}: {{ (+form.get("sumFormControl")?.value + +commission).toFixed(2) }} {{ currency }}
      </p>
    </div>
    <div class="payment-card__right-commission">
      <p class="commission-sum">{{ "PAYMENT_TO_CARD_PAGE.SUM_COMMISSION" | translate }}: {{ commission }} {{ currency }}</p>
    </div>
    <div class="btn-block">
      <button
        [disabled]="cardFromValidate || form.invalid || isSending || time < 0"
        (click)="sendP2p()"
        type="submit"
        class="btn btn-accent">
        {{ "PAYMENT_TO_CARD_PAGE.PAYMENT" | translate }}
      </button>
      <button
        (click)="clearForm()"
        type="button"
        class="btn btn-light">
        {{ "PAYMENT_TO_CARD_PAGE.CLEAR" | translate }}
      </button>
    </div>
  </form>
  <div
    *ngIf="!virtualPosId && loaded"
    class="payment-card__right">
    <h3 class="payment-card__right-error">
      {{ "PAYMENT_TO_CARD_PAGE.ERROR" | translate }}
    </h3>
  </div>
</div>
